import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify'

const baseURL = axios.create()
baseURL.defaults.baseURL = "https://zibaeslami.com/api/v1";

const axiosResponseError = (error) => {
    if(error.response.status == 401){
        window.location.replace('/auth/login')
    }
    else if (error.response) {
        toast.error(error.response.data.error);
    } else {
        console.log(error);
        toast.error("خطا در اتصال لطفا دوباره تلاش نمایید!");
    }
};

const axiosRequestError = (error) => {
    if (error.request) {
        toast.warning("عدم ارسال اطلاعات");
    }
};

let toastID;

const auth = JSON.parse(localStorage.getItem("za_token"));

baseURL.interceptors.request.use(
    (request) => {
        if (request.method === "post") {
            if (request.url.includes("upload")) {
                toastID = toast.loading("در حال بارگزاری فایل ...")
            }
        }
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            ...request.headers,
        };
        // if (auth && !request.headers.Authorization) {
        headers["Authorization"] = `${"Bearer " + auth?.token}`;
        // }
        request.headers = headers;
        return request;
    },
    (error) => {
        axiosRequestError(error);
        return Promise.reject(error);
    }
);

baseURL.interceptors.response.use(
    (response) => {
        if (response.request.responseURL.includes("upload")) {
            toast.dismiss(toastID);
            // toastID = toast.loading("در حال بارگزاری فایل ...")
        }
        
        return response;
    },
    (error) => {
        axiosResponseError(error);
        toast.dismiss(toastID);
        return Promise.reject(error);
    }
);

export default baseURL;

// const publicHeaders = {
//     headers: {
//         Authorization: "Bearer " + auth?.token,
//         accept: "application/json"
//     }
// }
